import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import baseUrl from './baseUrl';

const initialState = {
    activeMenu: null,
    activeRole: null,
    loginStatus: false,
    status: 'idle',
    error: null
};

export const activeMenu = createAsyncThunk('activeMenu', async menu => {
    return menu;
});

export const activeRole = createAsyncThunk('activeRole', async role => {
    return role;
});

const menuSlice = createSlice({
    name: 'login',
    initialState,

    reducers: {
        // Define any additional synchronous actions here if needed
    },
    extraReducers: builder => {
        builder
            .addCase(activeMenu.pending, state => {
                state.loading = true;
                state.error = null;
            })
            .addCase(activeMenu.fulfilled, (state, action) => {
                state.loading = false;
                state.activeMenu = action.payload;
                state.error = null;
            })
            .addCase(activeMenu.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            });
        builder
            .addCase(activeRole.pending, state => {
                state.loading = true;
                state.error = null;
            })
            .addCase(activeRole.fulfilled, (state, action) => {
                state.loading = false;
                state.activeRole = action.payload;
                state.error = null;
            })
            .addCase(activeRole.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            });
    }
});

// Export the reducer
export default menuSlice.reducer;
